import React from "react";
import s from "./Additions.module.css";
import TabsFancyTitle from "../TabsFancyTitle";
import Link from "../../_shared/Link";
import { Mobile, Desktop } from "../../_shared/Bp";
import FancyTitle from "../../_shared/FancyTitle";

function Card({ icon, link, description }) {
  return (
    <Link settings={link} className={s.card}>
      {icon && <img src={icon} alt={link.label} />}
      <div>
        <div className={s.title}>{link.label}</div>
        {description && <div className={s.description}>{description}</div>}
      </div>
    </Link>
  );
}

function Additions({ data }) {
  return (
    <div className={s.additions}>
      <Desktop>
        <TabsFancyTitle title={data.title} />
      </Desktop>

      <Mobile>
        <FancyTitle title={data.title} />
      </Mobile>

      <div className={s.cards}>
        {data.cards.map((card) => (
          <Card key={card.id} {...card} />
        ))}
      </div>
    </div>
  );
}

export default Additions;
